<template>
  <div class="relative hidden h-10 items-center rounded-md shadow-sm sm:flex">
    <button
      v-if="options.includes('card')"
      @click="setMode('card')"
      type="button"
      :class="[value === 'card' ? 'mode-active' : 'mode-inactive', 'button']"
    >
      <i v-html="showSpinner && value === 'card' ? $icons.loading : $icons.card_sm"></i>
    </button>
    <button
      v-if="options.includes('mini-card')"
      @click="setMode('mini-card')"
      type="button"
      :class="[value === 'mini-card' ? 'mode-active' : 'mode-inactive', 'button']"
    >
      <i v-html="showSpinner && value === 'mini-card' ? $icons.loading : $icons.menu_sm"></i>
    </button>
    <button
      v-if="this.$screen.xl && options.includes('list')"
      @click="setMode('list')"
      type="button"
      :class="[value === 'list' ? 'mode-active' : 'mode-inactive', 'button']"
    >
      <i v-html="showSpinner && value === 'list' ? $icons.loading : $icons.investments_list"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    showSpinner: {
      type: Boolean,
    },
    value: {
      type: String,
      validator: (value) => {
        return ["card", "mini-card", "list"].includes(value);
      },
    },
    options: {
      type: Array,
      default: () => {
        return ["card", "mini-card", "list"];
      },
      validator: (val) => {
        return val.every((item) => ["card", "mini-card", "list"].includes(item));
      },
    },
  },
  methods: {
    setMode(value) {
      this.$emit("input", value);
    },
  },
  watch: {
    "$screen.xl": {
      handler(val) {
        if (this.value === "list" && val === false) {
          this.$emit("input", "card");
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  @apply relative -ml-px inline-flex h-full items-center border px-2 text-sm font-medium first:rounded-l-lg last:rounded-r-lg focus:outline-none;
  &.mode-active {
    @apply border-ontick-steel-200 text-ontick-blue-600 dark:border-ontick-steel-500 dark:bg-ontick-steel-500 bg-gray-300;
  }
  &.mode-inactive {
    @apply border-ontick-steel-200 dark:border-ontick-steel-600 dark:bg-ontick-steel-700 bg-gray-200 text-gray-500 dark:text-gray-400;
  }
}
</style>
